import { render, staticRenderFns } from "./KnTabsRow.vue?vue&type=template&id=63289db0"
import script from "./KnTabsRow.vue?vue&type=script&lang=js"
export * from "./KnTabsRow.vue?vue&type=script&lang=js"
import style0 from "./KnTabsRow.vue?vue&type=style&index=0&id=63289db0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports